import React from 'react';
import MenuCategory from './MenuCategory';

export default function MenuColumn({ categories = [], menuItems = {} }) {
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div className="space-y-8">
      {categories.map(category => (
        <MenuCategory
          key={category}
          title={category}
          items={menuItems[category] || []}
        />
      ))}
    </div>
  );
}